<script>
  import Quicklinks from '@/views/app/dashboard/footer-pages/components/Quicklinks.vue';

  export default {
    name: 'InjectAppBar',
    components: { Quicklinks },
    computed: {
      component() {
        return this.$store.getters.getInjectedComponent;
      },
    },
  };
</script>

<template>
  <component
    v-if="component.name"
    :is="component.name"
    v-bind="component.props"
    v-on="component.on ? { click: component.on.click } : {}"
  />
</template>

<style scoped lang="scss"></style>
